import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { usersState } from "./type";
interface LoginPayload {
  // Add appropriate types for the payload
}

export const getAllAdminUsers = createAsyncThunk(
  "web/get-admin-users",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/dropdown`);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        // console.log(data?.data?.data);

        const obj = data?.data?.data?.admin_users;
        thunkAPI.dispatch(SET_ADMIN_USERS(obj));
        // SET_CUSTOMERS(obj);
        // return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getAllAdminUsersPaginated = createAsyncThunk(
  "web/get-admin-users-paginated",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/admin-users?page=${payload?.page || 1}${
          payload?.search ? `&search=${payload?.search}` : ``
        }${payload?.roles ? `&filter[roles]=${payload?.roles}` : ``}`
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        // console.log(data?.data);

        const obj = data?.data?.data?.admin_users;
        thunkAPI.dispatch(SET_ADMIN_USERS_PAGINATION(obj));
        // SET_CUSTOMERS(obj);
        // return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const getAllAdminUsersActivity = createAsyncThunk(
  "web/get-admin-users-activity",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/activities?page=${payload?.page || 1}
        ${payload?.search ? `&search=${payload?.search}` : ``}${
          payload?.date ? `&filter[date]=${payload?.date}` : ``
        }${payload?.role ? `&filter[role]=${payload?.role}` : ``}${
          payload?.type ? `&filter[type]=${payload?.type}` : ``
        }
        `
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        thunkAPI.dispatch(SET_ADMIN_USERS_ACTIVITY(obj));
        // SET_CUSTOMERS(obj);
        // return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const createAdminUserInvite = createAsyncThunk(
  "web/create-admin-user-invite",
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const data = await axios.post("/admin/invite-admin-user", payload);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const deleteAdminUserInvite = createAsyncThunk(
  "web/delete-admin-user-invite",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.delete(`/admin/${payload?.id || ""}`, payload);
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const resendAdminUserInvite = createAsyncThunk(
  "web/resend-admin-user-invite",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.post(
        `/admin/invite-admin-user/${payload?.id || ""}`,
        payload
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

export const editAdminUserInvite = createAsyncThunk(
  "web/edit-admin-user-invite",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.put(
        `/admin/edit-user/${payload?.admin_user_id}`,
        payload
      );
      

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      //   console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  }
);

const initialState: usersState = {
  loading: false,
  loading_users: false,
  admin_users: [],
  admin_users_paginated: {},
  admin_users_activity: {},
  // initialize other state properties
};

const addLabelValue = (list: any) => {
  if (list?.length > 0) {
    const newList = list?.map((chi: any) => {
      return {
        ...chi,
        label: `${chi?.first_name || ""} ${chi?.last_name || ""}`,
        value: chi?.id,
      };
    });
    return newList;
  }
};

export const usersSlice = createSlice({
  name: "users",
  initialState,

  reducers: {
    SET_ADMIN_USERS: (state, action) => {
      state.admin_users = addLabelValue(action.payload);
    },
    SET_ADMIN_USERS_PAGINATION: (state, action) => {
      state.admin_users_paginated = action.payload;
    },
    SET_ADMIN_USERS_ACTIVITY: (state, action) => {
      state.admin_users_activity = action.payload;
    },
  },

  extraReducers: (builder) => {
    // pending state changes
    builder.addCase(getAllAdminUsersPaginated.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllAdminUsersPaginated.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllAdminUsersPaginated.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllAdminUsers.pending, (state) => {
      state.loading_users = true;
    });
    builder.addCase(getAllAdminUsers.fulfilled, (state) => {
      state.loading_users = false;
    });
    builder.addCase(getAllAdminUsers.rejected, (state) => {
      state.loading_users = false;
    });
    builder.addCase(createAdminUserInvite.pending, (state) => {
      state.loading_users = true;
    });
    builder.addCase(createAdminUserInvite.fulfilled, (state) => {
      state.loading_users = false;
    });
    builder.addCase(createAdminUserInvite.rejected, (state) => {
      state.loading_users = false;
    });
    builder.addCase(editAdminUserInvite.pending, (state) => {
      state.loading_users = true;
    });
    builder.addCase(editAdminUserInvite.fulfilled, (state) => {
      state.loading_users = false;
    });
    builder.addCase(editAdminUserInvite.rejected, (state) => {
      state.loading_users = false;
    });
    builder.addCase(deleteAdminUserInvite.pending, (state) => {
      state.loading_users = true;
    });
    builder.addCase(deleteAdminUserInvite.fulfilled, (state) => {
      state.loading_users = false;
    });
    builder.addCase(deleteAdminUserInvite.rejected, (state) => {
      state.loading_users = false;
    });
    builder.addCase(getAllAdminUsersActivity.pending, (state) => {
      state.loading_users = true;
    });
    builder.addCase(getAllAdminUsersActivity.fulfilled, (state) => {
      state.loading_users = false;
    });
    builder.addCase(getAllAdminUsersActivity.rejected, (state) => {
      state.loading_users = false;
    });
    builder.addCase(resendAdminUserInvite.pending, (state) => {
      state.loading_users = true;
    });
    builder.addCase(resendAdminUserInvite.fulfilled, (state) => {
      state.loading_users = false;
    });
    builder.addCase(resendAdminUserInvite.rejected, (state) => {
      state.loading_users = false;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  SET_ADMIN_USERS,
  SET_ADMIN_USERS_PAGINATION,
  SET_ADMIN_USERS_ACTIVITY,
} = usersSlice.actions;

export default usersSlice.reducer;
